export const getDePseudonymedResultIds = (state) => state.persistStore.dePseudonymResultIds;